import { isCfb } from './cfb';
import { trimSheet } from './trim';
import { parseXls } from './xls';
import { parseXlsx } from './xlsx';
import type { Sheet } from './types';

export type {
  Sheet,
  SheetCell,
  SheetMerge,
  SheetImage,
  CellStyle,
  CellIcon,
  CellLink,
  DataBar,
  CellBorders,
  BorderEdge,
  BorderStyle,
  FontStyle,
  TextRun,
  HorizontalAlign,
  VerticalAlign,
} from './types';

function toUint8Array(data: string | ArrayBuffer | Uint8Array): Uint8Array {
  if (typeof data !== 'string') {
    return data instanceof Uint8Array ? data : new Uint8Array(data);
  }
  // FileReader.readAsBinaryString отдаёт строку, где каждый символ — байт
  const bytes = new Uint8Array(data.length);
  for (let i = 0; i < data.length; i++) {
    bytes[i] = data.charCodeAt(i) & 0xff;
  }
  return bytes;
}

/** Формат определяем по сигнатуре, а не по расширению: xlsx — zip, xls — OLE2-контейнер. */
export async function parseSpreadsheet(data: string | ArrayBuffer | Uint8Array | Blob): Promise<Sheet[]> {
  const bytes = data instanceof Blob ? new Uint8Array(await data.arrayBuffer()) : toUint8Array(data);
  if (bytes[0] === 0x50 && bytes[1] === 0x4b) {
    return (await parseXlsx(bytes)).map(trimSheet);
  }
  if (isCfb(bytes)) {
    return parseXls(bytes).map(trimSheet);
  }
  throw new Error('Неизвестный формат файла');
}
